// removed by extract-text-webpack-plugin
module.exports = {"container":"comparedSeries__container___2ok1j","circle":"comparedSeries__circle___3Wjdm","content":"comparedSeries__content___2Hsgj","title":"comparedSeries__title___cDiyF","subInfoContainer":"comparedSeries__subInfoContainer___1PGm3","subInfo":"comparedSeries__subInfo___FW2Zl","label":"comparedSeries__label___3r8Xv","num":"comparedSeries__num___upM3s"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/lib/cards/comparedSeries.css
// module id = 1569
// module chunks = 0